import React from 'react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps {
  name: string;
  label: string;
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  tooltip?: React.ReactNode;
  autoAdvance?: boolean;
}
export function Select({
  name,
  label,
  options,
  value,
  onChange,
  required,
  tooltip,
  autoAdvance = false
}: SelectProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    if (newValue) {
      onChange(newValue);
    }
  };
  return <div className="space-y-2" data-id="element-264">
      <label htmlFor={name} className="flex items-center text-base font-medium text-gray-900" data-id="element-265">
        {label}
        {required && <span className="text-red-600 ml-1" data-id="element-266">*</span>}
        {tooltip}
      </label>
      <select id={name} name={name} value={value} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 bg-white hover:border-yellow-500 hover:shadow-[0_0_8px_rgba(234,179,8,0.4)] focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500 focus:shadow-[0_0_12px_rgba(234,179,8,0.5)] focus:outline-none transition-all duration-300" style={{
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
      backgroundPosition: 'right 0.5rem center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '1.5em 1.5em',
      paddingRight: '2.5rem',
      appearance: 'none'
    }} data-id="element-267">
        <option value="" data-id="element-268">Select...</option>
        {options.map(option => <option key={option.value} value={option.value} data-id="element-269">
            {option.label}
          </option>)}
      </select>
    </div>;
}